import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import api, { normalize } from '../services/api';
import './Dashboard.css';

function formatWidgetValue(id, valor) {
  if (id === 'faturamento_mes') {
    return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  return Number(valor || 0).toLocaleString('pt-BR');
}

export default function BiDashboardPage({ embedded = false }) {
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data: res } = await api.get('/bi/dashboard');
        setData(normalize(res));
      } catch (e) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: e.response?.data?.message || 'Falha ao carregar BI.',
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className={embedded ? '' : 'dashboard-page'}>
      <Toast ref={toast} />
      {!embedded && (
        <>
          <h1>Business Intelligence</h1>
          <p className="dashboard-subtitle">Indicadores de emissão e tomadas</p>
        </>
      )}
      {embedded && (
        <p className="dashboard-subtitle" style={{ marginTop: 0 }}>
          Indicadores de emissão e tomadas
        </p>
      )}

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
          <ProgressSpinner style={{ width: 48, height: 48 }} strokeWidth="4" />
        </div>
      )}

      {!loading && data?.bloqueado && (
        <div className="dashboard-card">
          <h2>Add-on BI</h2>
          <p>{data.message || 'Plano atual não inclui o add-on de BI.'}</p>
        </div>
      )}

      {!loading && data && !data.bloqueado && (
        <>
          <div className="dashboard-grid">
            {(data.widgets || []).map((w) => (
              <div key={w.id} className="dashboard-widget">
                <i className="pi pi-chart-bar" />
                <h3>{w.titulo}</h3>
                <p style={{ fontSize: '1.4rem', fontWeight: 700, color: '#002478', margin: 0 }}>
                  {formatWidgetValue(w.id, w.valor)}
                </p>
              </div>
            ))}
          </div>

          {data.metadata && (
            <div className="dashboard-card" style={{ marginTop: '1.5rem' }}>
              <h2>Metadados sugeridos</h2>
              <p style={{ color: '#64748b', margin: '0 0 0.5rem' }}>
                Entidades: {(data.metadata.entidades || []).join(', ')}
              </p>
              <p style={{ color: '#64748b', margin: 0 }}>
                Campos: {(data.metadata.camposSugeridos || []).join(', ')}
              </p>
            </div>
          )}

          <div className="dashboard-grid" style={{ marginTop: '1rem' }}>
            <Link to="/nfse/emissor" className="dashboard-widget" style={{ textDecoration: 'none' }}>
              <i className="pi pi-file" />
              <h3>Ver emitidas</h3>
              <p>Abrir consulta do emissor</p>
            </Link>
            <Link to="/nfse/tomadas" className="dashboard-widget" style={{ textDecoration: 'none' }}>
              <i className="pi pi-inbox" />
              <h3>Ver tomadas</h3>
              <p>Abrir NFS-e destinadas</p>
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
